<template>
  <div class="app-search-root">
    <el-breadcrumb separator="/" class="title">
      <el-breadcrumb-item
        :to="{
          name: 'Apps',
          params: {
            filterTerm: filterTerm,
            curTabLabel: curTabLabel,
            dragShow: dragShow,
          },
          query: { project: currentProjectId },
        }"
        >应用列表</el-breadcrumb-item
      >
      <el-breadcrumb-item>按安装包信息搜索</el-breadcrumb-item>
    </el-breadcrumb>
    <TakoPanel class="centent" :header="true">
      <template #header>
        <div class="header">
          <span class="back" @click="handleGoBack">
            <i class="iconfont icon-leftarrow"></i>
            返回
          </span>
        </div>
      </template>
      <div class="content-body">
        <div class="bar">
          <el-input
            size="large"
            @keyup.enter="handleSearch"
            v-model="searchTerm"
            style="width: 240px; margin-right: 12px"
            placeholder="版本/包名/标签筛选,支持正则"
          ></el-input>
          <el-button size="large" type="primary" @click="handleSearch"
            >查&nbsp;询</el-button
          >
        </div>
        <el-table
          :data="tableData"
          :span-method="objectSpanMethod"
          style="width: 100%"
          v-loading="appVersionsLoading"
        >
          <el-table-column :label="'应用名称'" :width="140">
            <template #default="scope">
              <router-link
                :to="{
                  name: 'Apps',
                  query: {
                    action: 'detail',
                    project: currentProjectId,
                    appid: scope.row.appid,
                  },
                }"
                style="color: #409eff"
              >
                {{ scope.row.app.appname }}
              </router-link>
            </template>
          </el-table-column>

          <el-table-column :label="'所属平台'" align="center" :width="100">
            <template #default="scope">
              <i
                :class="[
                  'iconfont',
                  'icon-' + iconEnum[scope.row.app.platform - 1],
                ]"
                :style="{
                  'font-size': '20px',
                  color: iconColorEnum[scope.row.app.platform - 1],
                }"
              ></i>
            </template>
          </el-table-column>

          <el-table-column :label="'版本名称'" width="180">
            <template #default="scope">
              {{ scope.row.package.appname }}
            </template>
          </el-table-column>

          <el-table-column :label="'构建版本'" width="100">
            <template #default="scope">
              <router-link
                :to="{
                  name: 'Apps',
                  query: {
                    action: 'detail',
                    project: currentProjectId,
                    appid: scope.row.appid,
                  },
                  params: {
                    searchTerm: scope.row.package.version,
                  },
                }"
                style="color: #409eff"
              >
                {{ scope.row.package.version }}
              </router-link>
            </template>
          </el-table-column>

          <el-table-column :label="'构建号'" width="80">
            <template #default="scope">
              {{ scope.row.package.buildnumber }}
            </template>
          </el-table-column>

          <el-table-column
            :label="'包名'"
            :show-overflow-tooltip="true"
            width="200"
          >
            <template #default="scope">
              {{ scope.row.package.bundleid }}
            </template>
          </el-table-column>

          <el-table-column
            :label="'更新简要'"
            :show-overflow-tooltip="true"
            min-width="150"
          >
            <template #default="scope">
              {{ scope.row.releasenote }}
            </template>
          </el-table-column>

          <el-table-column :label="'文件大小'" width="90">
            <template #default="scope">{{
              humanSize(scope.row.package.size, 2)
            }}</template>
          </el-table-column>

          <el-table-column :label="'存储'" width="120">
            <template #default="scope">
              <div class="">
                <span
                  v-if="
                    scope.row.package.lanurl && scope.row.lan_storage_status
                  "
                  :class="
                    scope.row.lan_storage_status &&
                    scope.row.lan_storage_status === 'LanDeleted'
                      ? 'textDecoration'
                      : ''
                  "
                  >内网</span
                >
                <span
                  v-if="
                    scope.row.package.url != '' &&
                    scope.row.package.url != 'uploading' &&
                    scope.row.package.url != 'failed' &&
                    scope.row.wan_storage_status
                  "
                  :class="
                    scope.row.wan_storage_status &&
                    scope.row.wan_storage_status === 'WanDeleted'
                      ? 'textDecoration'
                      : ''
                  "
                  >云端</span
                >
              </div>
            </template>
          </el-table-column>

          <el-table-column :label="'标签'" min-width="120">
            <template #default="scope">
              <div style="display: flex">
                <template v-for="(item, index) in scope.row.tags">
                  <div
                    :key="index"
                    v-if="scope.row.tags.length !== 0"
                    style="margin-right: 10px"
                  >
                    {{ item }}
                  </div>
                </template>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            :label="'创建时间'"
            :show-overflow-tooltip="true"
            width="140"
          >
            <template #default="scope">{{
              formatDateTime(scope.row.createtime)
            }}</template>
          </el-table-column>
          <el-table-column :width="120" label="操作">
            <template #default="scope">
              <el-tooltip
                v-if="scope.row.activityid && isAdmin"
                content="取消分享"
                :show-after="300"
                :enterable="false"
                placement="top"
              >
                <el-button
                  size="small"
                  plain
                  type="warning"
                  @click="handleDelShare(scope.row)"
                  style="margin: 2px 4px 2px 0"
                >
                  <i class="iconfont icon-scissors-fill"></i>
                </el-button>
              </el-tooltip>
              <el-tooltip
                :content="scope.row.activityid ? '打开分享页' : '分享该版本'"
                :show-after="300"
                :enterable="false"
                placement="top"
              >
                <el-button
                  :disabled="
                    (scope.row.package.lanurl == '' ||
                      scope.row.lan_storage_status === 'LanDeleted') &&
                    (scope.row.package.url == '' ||
                      scope.row.wan_storage_status === 'WanDeleted')
                  "
                  size="small"
                  plain
                  type="primary"
                  @click="handleShareOrOpen(scope.row)"
                  v-if="scope.row.activityid ? true : isAdmin"
                  style="margin: 2px 0"
                >
                  <i
                    :class="[
                      'iconfont',
                      scope.row.activityid
                        ? 'icon-up-right-from-square'
                        : 'icon-share-nodes',
                    ]"
                  ></i>
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <Pagination
          :total="page.total"
          :size="page.size"
          :onPageChange="handelChangePage"
        />
      </div>
    </TakoPanel>
  </div>
</template>

<script setup>
import { getCurrentInstance, onMounted, reactive, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { storeToRefs } from "pinia";
import { useProjectStore } from "@/Store/ProjectStore";
import TakoPanel from "@/Components/TakoPanel.vue";
import Pagination from "@/Components/Pagination.vue";
import {
  humanSize,
  formatDateTime,
  getDownloadBaseUrl,
} from "@/Utils/UtilTools";
import {
  apiClosureVersion,
  apiGetAppAllVersions,
  apiShareVersion,
} from "@/Api/AppApi";

const { appContext } = getCurrentInstance();
const $message = appContext.config.globalProperties.$message;
const router = useRouter();
const route = useRoute();

const projectStore = useProjectStore();
const { currentProjectId, isAdmin } = storeToRefs(projectStore);

const iconColorEnum = [
  "rgba(142, 142, 142, 1)",
  "rgba(109, 193, 101, 1)",
  "rgba(18, 150, 219, 1)",
  "rgba(142, 142, 142, 1)",
  "rgba(0, 0, 0, 1)",
];
const iconEnum = ["apple", "android", "windows", "app-store", "linux"];

let filterTerm = ref(""),
  curTabLabel = ref(""),
  dragShow = ref(false);
onMounted(() => {
  const params = route.params;
  if (params.filterTerm != undefined) {
    filterTerm.value = params.filterTerm.toString();
  }
  if (params.curTabLabel != undefined) {
    curTabLabel.value = params.curTabLabel.toString();
    dragShow.value = !!params.dragShow;
  }
});
function handleGoBack() {
  router.push({
    name: "Apps",
    params: {
      filterTerm: filterTerm.value,
      curTabLabel: curTabLabel.value,
      dragShow: dragShow.value,
    },
    query: { project: currentProjectId.value },
  });
}

const tableData = ref([]);
const page = reactive({
  size: 10,
  total: 0,
  current: 0,
});
function handelChangePage(p) {
  page.current = p - 1;
  getAppVersions();
}

const appVersionsLoading = ref(false);
const searchTerm = ref("");
let term = "";
async function handleSearch() {
  term = searchTerm.value.trim();
  if (term === '') {
    $message.warning('请输入搜索内容');
    return
  }
  getAppVersions();
}

let spanArr = [];
function objectSpanMethod({ rowIndex, columnIndex }) {
  // 合并行
  if (columnIndex === 0 || columnIndex === 1) {
    const _row = spanArr[rowIndex];
    const _col = _row > 0 ? 1 : 0;
    return {
      // [0,0] 表示这一行不显示， [2,1]表示行的合并数
      rowspan: _row,
      colspan: _col,
    };
  }
}
function getSpanArr(data) {
  spanArr = [];
  let pos;
  for (let i = 0; i < data.length; i++) {
    if (i === 0) {
      spanArr.push(1);
      pos = 0;
    } else {
      // 判断当前元素与上一个元素是否相同
      if (data[i].appid === data[i - 1].appid) {
        spanArr[pos] += 1;
        spanArr.push(0);
      } else {
        spanArr.push(1);
        pos = i;
      }
    }
  }
}

async function getAppVersions() {
  const params = {
    project_id: currentProjectId.value,
    count: page.size,
    cursor: page.current * page.size,
  };

  if (term) {
    params.regex = term;
  }

  appVersionsLoading.value = true;
  const res = await apiGetAppAllVersions(params);
  appVersionsLoading.value = false;
  if (res.code === 0) {
    page.total = res.data.data.page
      ? res.data.data.page.total
      : res.data.allrows;
    const versions =
      res.data.data.version_detail.sort((a, b) => a.appid - b.appid) || [];
    // 如果后端没有返回 tags，则会导致 vue 的响应式无法处理 tags 的更新, 这里补上这个字段
    versions.forEach(function (ver) {
      if (ver.tags == undefined) {
        ver.tags = [];
      }
      ver.edit = false; //标志位,修改App的名称
    });

    getSpanArr(versions);
    tableData.value = versions;
  } else {
    $message.error(res.message);
  }
}

async function handleDelShare(row) {
  const res = await apiClosureVersion(currentProjectId.value, row.id);
  if (res.code === 0) {
    getAppVersions();
  } else {
    $message.error(res.message);
  }
}

const baseUrl = getDownloadBaseUrl(router);
async function handleShareOrOpen(row) {
  const res = await apiShareVersion(currentProjectId.value, row.id);
  if (res.code === 0) {
    getAppVersions();

    // 打开下载页面
    window.open(baseUrl + row.id);
  } else {
    $message.error(res.message);
  }
}
</script>

<style lang="scss" scoped>
.title {
  width: 100%;
  padding-left: 35px;
  padding-top: 15px;
  margin-bottom: 20px;
}

.header {
  color: #606266;

  .back {
    font-size: 14px;
    cursor: pointer;

    &:hover {
      color: #409eff;
    }
  }
}

.centent {
  margin: 20px;

  .content-body {
    padding: 20px;
  }
}
</style>
